import React, { useMemo, useState } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { useChartCategorySpend } from '../../../hooks/useChartData';
import ChartCard from '../wrappers/ChartCard';
import TransactionDrilldownModal from '../wrappers/TransactionDrilldownModal';
import nivoCustomTheme from '../theme/nivoCustomTheme';
import useResponsive from '../../../hooks/useResponsive';

const formatCLP = (v) => `$${Math.round(v).toLocaleString('es-CL')}`;

export default function CategoryBarChart({ dateFrom, dateTo, categoryIds }) {
  const { isMobile } = useResponsive();
  const { data, loading, error } = useChartCategorySpend({ dateFrom, dateTo, categoryIds });
  const [drilldown, setDrilldown] = useState(null);

  const chartData = useMemo(
    () => data?.chartCategorySpend ?? [],
    [data]
  );

  const handleClick = (bar) => {
    setDrilldown({
      categoryName: bar.indexValue,
      dateFrom: dateFrom ? dateFrom.format('YYYY-MM-DD') : null,
      dateTo: dateTo ? dateTo.format('YYYY-MM-DD') : null,
    });
  };

  return (
    <>
      <ChartCard
        title="Gastos por Categoría"
        subtitle="Suma total de egresos por categoría"
        loading={loading && !data}
        error={error}
        height={{ xs: Math.max(280, chartData.length * 44), md: Math.max(280, chartData.length * 44) }}
      >
        <ResponsiveBar
          data={chartData}
          keys={['total']}
          indexBy="category"
          layout="horizontal"
          colors={(bar) => bar.data.color}
          theme={nivoCustomTheme}
          margin={isMobile
            ? { top: 0, right: 50, bottom: 40, left: 110 }
            : { top: 0, right: 100, bottom: 40, left: 140 }
          }
          padding={0.3}
          axisBottom={{
            tickSize: 0,
            tickPadding: 8,
            tickValues: isMobile ? 4 : undefined,
            format: (v) => `$${(v / 1000).toFixed(0)}k`,
            legend: 'Gasto (CLP)',
            legendPosition: 'middle',
            legendOffset: 36,
          }}
          axisLeft={{
            tickSize: 0,
            tickPadding: 8,
            tickRotation: isMobile ? -30 : 0,
          }}
          enableGridX={true}
          enableGridY={false}
          labelSkipWidth={60}
          label={(d) => formatCLP(d.value)}
          onClick={handleClick}
          role="button"
          tooltip={({ indexValue, value, color }) => (
            <div style={{ background: '#fff', padding: '8px 12px', borderRadius: 8, border: '1px solid #E8E5DF', boxShadow: '0 4px 20px rgba(0,0,0,0.10)', fontSize: 12 }}>
              <span style={{ display: 'inline-block', width: 10, height: 10, background: color, borderRadius: 2, marginRight: 6 }} />
              <strong>{indexValue}</strong>: {formatCLP(value)}
            </div>
          )}
          animate={true}
          motionConfig="gentle"
        />
      </ChartCard>

      {drilldown && (
        <TransactionDrilldownModal
          open={!!drilldown}
          onClose={() => setDrilldown(null)}
          categoryName={drilldown.categoryName}
          dateFrom={drilldown.dateFrom}
          dateTo={drilldown.dateTo}
        />
      )}
    </>
  );
}
